module.exports = __webpack_public_path__ + "static/media/community12.01ceef71.svg";